import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store/index.js'
import i18n, { getActiveLocale } from './i18n'
import Alert from './alert.js'
import Log, { globalLog } from './log.js'
import BootstrapVue from 'bootstrap-vue'
import iFieldCore from 'ifield-core-components'
import { ValidationProvider } from 'vee-validate'
import { ValidationObserver } from 'vee-validate'
import './validation.js'
import moment from 'moment'
import { RestApiClient } from 'ifield-core-components'
import { ENV_COMPANY_CODE_PLACEHOLDER } from '@/constants.js'

// サーバアドレス、ベースパス注入
const companyCode = new URL(location.href).hostname.split('.')[0]
RestApiClient.server = process.env.VUE_APP_SERVER.replace(
  ENV_COMPANY_CODE_PLACEHOLDER,
  companyCode
)
RestApiClient.basePath = process.env.VUE_APP_API_BASE_PATH

// moment.js の使用 locale (en以外)
import 'moment/dist/locale/ja'

import '@/assets/scss/main.scss'

Vue.config.productionTip = false

// Vuex,VueRouter,VueI18n についてはモジュール内で Vue.use 実行済み
Vue.use(BootstrapVue)
Vue.use(iFieldCore)
Vue.use(Alert)
Vue.use(Log)

// バリデーションコンポーネント登録
Vue.component('ValidationProvider', ValidationProvider)
Vue.component('ValidationObserver', ValidationObserver)

// moment の locale 設定
moment.locale(getActiveLocale())

// グローバルへの ifield オブジェクト挿入
globalThis.ifield = {
  log: globalLog,
  locale: getActiveLocale(),
  version: process.env.VUE_APP_VERSION,
}

new Vue({
  router,
  store,
  i18n,
  render: function (h) {
    return h(App)
  },
}).$mount('#app')
